import { Provider } from '@angular/core';

import { PROMOTION_MAP_INTEGRATION_TOKEN } from '@frontend/sports/crm/promotion/feature';

import { CrmPromotionProviderService } from './crm-promotion-provider.service';

export function providePromotionsMapIntegration(): Provider {
    return {
        provide: PROMOTION_MAP_INTEGRATION_TOKEN,
        useExisting: CrmPromotionProviderService,
    };
}
